export default __webpack_public_path__ + "static/media/timeline-3.b51f1b7c.png";